export default __webpack_public_path__ + "static/media/40-min.3b97cc2e.png";